import React from 'react';
import styled from 'styled-components';

import { IconButton } from 'components/molecules/Button';
import { ButtonText } from 'components/atoms/Text';

const ButtonContainer = styled.div`
    z-index: 1000;
    padding: 6px;
    background: white;
    border-radius: 6px;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1), 0px 2px 2px rgba(0, 0, 0, 0.03);
    display: ${(props) => (props.showPopUp ? 'flex' : 'none')};
    flex-direction: row;
    justify-content: center;
    gap: 5px;
    align-items: center;
    height: 32px;
    width: fit-content;
    position: absolute;
    bottom: -20px;
    ${(props) => (props.right ? 'right: 8px;' : 'left: 8px;')}

    &:hover {
        cursor: pointer;
    }
`;

const StyledIconButton = styled(IconButton)`
    border-radius: 6px;
    padding: 0;

    &:hover {
        background-color: #efedff;
    }
`;

const MessagePopUpButton = ({ text, showPopUp = false, width = null, right = true, typeCallback, ...props }) => {
    return (
        <ButtonContainer showPopUp={showPopUp} width={width} right={right} {...props}>
            {right ? (
                <>
                    <StyledIconButton
                        onClick={() => typeCallback('copy')}
                        kind={'copy'}
                        iconColor={'#212121'}
                        size={24}
                        iconSize={'16px'}
                    />
                    {/* <IconButton
                        onClick={() => typeCallback('edit')}
                        kind={'edit'}
                        iconColor={'rgba(0, 0, 0, 0.87)'}
                        size={25}
                    /> */}
                    <StyledIconButton
                        onClick={() => typeCallback('delete')}
                        kind={'trashCan'}
                        iconColor={'#212121'}
                        size={24}
                        iconSize={'16px'}
                    />
                </>
            ) : (
                <>
                    <StyledIconButton
                        onClick={() => typeCallback('copy')}
                        kind={'copy'}
                        iconColor={'#212121'}
                        size={24}
                        iconSize={'16px'}
                    />
                    <StyledIconButton
                        onClick={() => typeCallback('reply')}
                        kind={'reply'}
                        iconColor={'#212121'}
                        size={24}
                        iconSize={'16px'}
                    />
                </>
            )}
        </ButtonContainer>
    );
};

export default MessagePopUpButton;
